import { Outlet, useRouteLoaderData } from 'react-router-dom';
import Content from '../../components/content';
import { LayoutGrid } from 'lucide-react';
import { UserDto } from '@/lib/ServerApi';

export function UserLayout() {
    const { user } = useRouteLoaderData('user-details') as {
        user?: UserDto;
    };
    return (
        <Content
            headerTitle={user ? `Edit User: ${user.firstName} ${user.lastName}` : 'Add New User'}
            headerIcon={<LayoutGrid />}
            backNavLink="/organization/user-management">
            {{ content: <Outlet /> }}
        </Content>
    );
}
